import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import {
  ContraventionQuestionModel,
  RadioQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { LoadingCopy } from '../../../helper/textcopy/policies.text';
import { ReportsService } from '../../../services/reports.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'loading-policy',
  templateUrl: './loading.component.html',
})
export class LoadingComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = LoadingCopy;
  contraventionsQuestion = new ContraventionQuestionModel();
  maximumTime = new RadioQuestionModel();

  constructor(
    public global: Global,
    private reportsService: ReportsService,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setContraventionsQuestion();
    this.setMaximumTimeQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setContraventionsQuestion() {
    this.contraventionsQuestion.options = [
      { value: 'y', text: 'Y' },
      { value: 'n', text: 'N' },
      { value: 'q', text: 'Q' },
    ];
  }
  onContraventionsQuestionSelected(answerValue) {
    this.contraventionsQuestion.valuesSelected = answerValue;
    this.contraventionsQuestion.valuesSelected = this.contraventionsQuestion.valuesSelected.slice();
  }

  setMaximumTimeQuestion() {
    this.maximumTime.data = {
      title: this.textCopy.maximumTime,
      includeTitle: true,
      answers: [
        {
          text: 'yes',
          value: 'y',
        },
        {
          text: "no, there's no limit for continuous loading",
          value: 'n',
        },
      ],
    };
  }
  onMaximumTimeSelected(answerValue) {
    this.maximumTime.valueSelected = answerValue;
  }

  setSelectedContraventions() {
    this.reportsService.getOffences().subscribe((result) => {
      this.contraventionsQuestion.valuesSelected = [];
      result.forEach((contravention) => {
        // no contravention 15 and 77 for policies
        if (contravention.id === 15 || contravention.id === 77) {
          return;
        }
        const value = this.policiesAnswers[`14_1_${contravention.id}`];
        this.contraventionsQuestion.valuesSelected.push({
          id: contravention.id,
          value: value !== undefined ? value : 'n',
        });
      });
    });
  }

  setSelectedValues() {
    this.maximumTime.valueSelected = this.policiesAnswers['14_2'];
    this.setSelectedContraventions();
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [{ id: '14_2', description: this.maximumTime.valueSelected }];

    this.contraventionsQuestion.valuesSelected.forEach((contravention, index) => {
      policyList.push({ id: `14_1_${contravention['id']}`, description: contravention['value'] });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
